import type { TripPlannerChat } from 'tripPlanner/api/types'
import { getChatLastActivityTimestamp, getTimestampSortValue } from 'tripPlanner/utils/chatTimestamps'
import { stripContextTags } from 'tripPlanner/utils/contextTag'

export interface RecentAiChatItem {
  type: 'aiChat'
  id: number
  title?: string
  subtitle?: string
  description?: string
  updatedAt: string
  sortTimestamp: number
}

function getVisibleSubtitle(content: string | undefined): string | undefined {
  const visibleContent = content ? stripContextTags(content) : ''
  return visibleContent || undefined
}

export function buildRecentAiChatItem(chat: TripPlannerChat): RecentAiChatItem {
  const updatedAt = getChatLastActivityTimestamp(chat)

  return {
    type: 'aiChat',
    id: chat.id,
    title: chat.name,
    subtitle: getVisibleSubtitle(chat.latestUserMessage),
    description: chat.description,
    updatedAt,
    sortTimestamp: getTimestampSortValue(updatedAt),
  }
}
